export enum NodeName {
  TEXT_AREA = 'TEXTAREA'
}
